const DownloadEarn = () => import(/* webpackChunkName: "chunk-download" */ '../views/P5_Download/DownloadEarn/index.vue')
const Download = () => import(/* webpackChunkName: "chunk-download" */ '../views/P5_Download/Download/index.vue')
const DownloadAgent = () => import(/* webpackChunkName: "chunk-download" */ '../views/P5_Download/DownloadAgent/index.vue')

// prettier-ignore
const Routes = [
  {
    path: '/download', alias: '/echo-download', name: 'download', component: Download, meta: { hideVConsole: true }
  },
  {
    path: '/download-agent', name: 'download-agent', component: DownloadAgent, meta: { hideVConsole: true } 
  },
  {
    path: '/download-earn', name: 'download-earn', component: DownloadEarn, meta: { hideVConsole: true }
  }
]
export default Routes
